import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@services/api'

export function useCollections(search = '', status = '') {
  return useQuery({
    queryKey: ['collections', search, status],
    queryFn: async () => {
      const res = await apiClient.get<any>('/collections', {
        params: { search, status },
      })
      return res
    },
  })
}

export function useCollectionDetail(id?: number) {
  return useQuery({
    queryKey: ['collection-detail', id],
    queryFn: async () => {
      const res = await apiClient.get<any>(`/collections/${id}`)
      return res
    },
    enabled: !!id,
  })
}

export function useCollectionsSummary() {
  return useQuery({
    queryKey: ['collections-summary'],
    queryFn: async () => {
      const res = await apiClient.get<any>('/collections/summary')
      return res
    },
  })
}

export function useStoreCollections() {
  return useQuery({
    queryKey: ['store-collections'],
    queryFn: async () => {
      const res = await apiClient.get<any>('/collections/by-store')
      return res
    },
  })
}

export function useDashboardMetrics() {
  return useQuery({
    queryKey: ['dashboard-metrics'],
    queryFn: async () => {
      const res = await apiClient.get<any>('/analytics/dashboard')
      return res
    },
  })
}

export function useSalesAnalytics() {
  return useQuery({
    queryKey: ['sales-analytics'],
    queryFn: async () => {
      const res = await apiClient.get<any>('/analytics/sales')
      return res
    },
  })
}

export function useInventoryAnalytics() {
  return useQuery({
    queryKey: ['inventory-analytics'],
    queryFn: async () => {
      const res = await apiClient.get<any>('/analytics/inventory')
      return res
    },
  })
}

export function useProductPerformance() {
  return useQuery({
    queryKey: ['product-performance'],
    queryFn: async () => {
      const res = await apiClient.get<any>('/analytics/products')
      return res
    },
  })
}
